import React from "react";
// import { useSelector, useDispatch } from "react-redux";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

const ProjectPipeline = () => {
    const data = [
        {
            name: 'Partner 1',
            uv: 200,
            pv: 240,
            amt: 240,
        },
        {
            name: 'Partner 2',
            uv: 300,
            pv: 139,
            amt: 221,
        },
        {
            name: 'Partner 3',
            uv: 200,
            pv: 680,
            amt: 290,
        },
        {
            name: 'Partner 4',
            uv: 780,
            pv: 398,
            amt: 300,
        },
        {
            name: 'Partner 5',
            uv: 180,
            pv: 400,
            amt: 781,
        },
        {
            name: 'Partner 6',
            uv: 390,
            pv: 300,
            amt: 250,
        },
        {
            name: 'Partner 7',
            uv: 390,
            pv: 300,
            amt: 200,
        },
    ];  
    return (<>
        <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="card card-radius">
                    <div className="header card-header custum-bg-warning rounded">
                        <h2 className="text-white">Project Pipeline</h2>
                    </div>
                    <div className="body card-body-shadow">
                        <div className="row">
                            <div className="col-lg-12 col-md-6 col-sm-12 text-center">
                            <ResponsiveContainer width="100%" height={600}>
                                    <AreaChart
                                        width={500}
                                        height={400}
                                        data={data}
                                        margin={{
                                            top: 10,
                                            right: 30,
                                            left: 0,
                                            bottom: 0,
                                        }}
                                    >
                                        <XAxis dataKey="name" />
                                        <YAxis />
                                        <Tooltip />
                                        <Area type="monotone" dataKey="uv" stackId="1" stroke="#ca472f" fill="#ca472f" />
                                        <Area type="monotone" dataKey="pv" stackId="1" stroke="#b698c8" fill="#b698c8" />
                                        <Area type="monotone" dataKey="amt" stackId="1" stroke="#bc5090" fill="#bc5090" />
                                    </AreaChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default ProjectPipeline;